import Rules from '@/services/validation/rules/rules'
export default {
  data() {
    return {
      nameRules: [
        v => Rules.isRequired(v),
        v => Rules.maxLength(v, 7),
        v => /([12]\d{3}-(0[1-9]|1[0-2]))/.test(v) || 'Format must be YYYY-MM'
      ],
      isOpenRules: [v => Rules.isBoolean(v)]
    }
  }
}
